import type { TBannersList } from '../../types/advertising';
import type { GlobalState } from '../index';

export const getBannersFromStateSelector = (state: GlobalState): TBannersList => state.advertising.banners;
export const getIsLoadedBannersFromStateSelector = (state: GlobalState): boolean => state.advertising.loaded;
